export var TextDisplay;
(function (TextDisplay) {
    TextDisplay["Language"] = "language";
    TextDisplay["Key"] = "key";
})(TextDisplay || (TextDisplay = {}));
export var MessageType;
(function (MessageType) {
    MessageType["Language_Toggle"] = "toggle";
    MessageType["Language_Hover"] = "hover";
    MessageType["Language_CollectKey"] = "collect-key-v2";
    MessageType["Language_Init"] = "language-init";
    MessageType["Language_CheckInit"] = "language-check-init";
    MessageType["Language_SwitchDisplay"] = "switch-display";
    MessageType["Language_SetTranslations"] = "set-translations";
    MessageType["Language_InitInterceptor"] = "init-interceptor";
    MessageType["Date_OnSetLanguage"] = "date_on-set-language";
    MessageType["Date_Hover"] = "date_hover";
    MessageType["Number_OnSetLanguage"] = "number_on-set-language";
    MessageType["Number_Hover"] = "number_hover";
})(MessageType || (MessageType = {}));
